import React from 'react';
import Icon from '../../../components/AppIcon';

const AnalysisTabNavigation = ({ activeTab, onTabChange, tabCounts }) => {
  const tabs = [
    {
      id: 'all',
      label: 'All Issues',
      icon: 'List',
      count: tabCounts?.all
    },
    {
      id: 'gaps',
      label: 'Gap Detection',
      icon: 'AlertCircle',
      count: tabCounts?.gaps
    },
    {
      id: 'inconsistencies',
      label: 'Inconsistencies',
      icon: 'AlertTriangle',
      count: tabCounts?.inconsistencies
    },
    {
      id: 'contradictions',
      label: 'Contradictions',
      icon: 'XCircle',
      count: tabCounts?.contradictions
    },
    {
      id: 'language',
      label: 'Language Issues',
      icon: 'Type',
      count: tabCounts?.language
    },
    {
      id: 'resolved',
      label: 'Resolved',
      icon: 'CheckCircle',
      count: tabCounts?.resolved
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg mb-6">
      <div className="flex overflow-x-auto">
        {tabs?.map((tab) => (
          <button
            key={tab?.id}
            onClick={() => onTabChange(tab?.id)}
            className={`flex items-center gap-3 px-6 py-4 text-sm font-medium whitespace-nowrap border-b-2 transition-colors ${
              activeTab === tab?.id
                ? 'border-primary text-primary bg-primary/5' :'border-transparent text-muted-foreground hover:text-foreground hover:bg-muted/50'
            }`}
          >
            <Icon name={tab?.icon} size={16} />
            <span>{tab?.label}</span>
            {tab?.count > 0 && (
              <span className={`px-2 py-1 text-xs rounded-full ${
                activeTab === tab?.id
                  ? 'bg-primary text-primary-foreground'
                  : 'bg-muted text-muted-foreground'
              }`}>
                {tab?.count}
              </span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default AnalysisTabNavigation;